/* eslint-disable */
import {getUserToken, getDailyDate} from 'src/utils/utils'
import Qs from 'qs'
import axios from 'axios'
import state from 'src/store/state'
/* eslint-enable */
const APP_ID = 'wxf30717158142feba' // 这个是服务号的 APPID，仅在登录时使用

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    return response.data
  },
  function(error) {
    return Promise.reject(error)
  },
)

const urlEncode = function(param, key, encode) {
  if (param == null) return ''
  let paramStr = ''
  let t = typeof param
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr +=
      '&' +
      key +
      '=' +
      (encode == null || encode ? encodeURIComponent(param) : param)
  } else {
    for (let i in param) {
      let k =
        key == null
          ? i
          : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      paramStr += urlEncode(param[i], k, encode)
    }
  }
  return paramStr
}

const fillParams = (params = {}) => {
  const query = {}
  const keys = Object.keys(params)
  keys.forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      query[key] = params[key]
    }
  })
  return Object.assign(
    {
      token: getUserToken(),
      publication:
        state.route && state.route.params && state.route.params.publicationId,
    },
    query,
  )
}

export const buildQuery = function(params) {
  let result = fillParams(params)
  return '?' + urlEncode(result)
}

export function HOST(url) {
  if (location.host === 'console.readland.cn') {
    return 'http://api.readland.cn'
    // return 'http://api-staging.readland.cn'
  }
  if (url.startsWith('/ng')) {
    return 'http://api.readland.cn'
  }
  return 'http://api.readland.cn'
  // return 'http://api-staging.readland.cn'
}

// Ajax
export function Ajax(request) {
  if (typeof request === 'string' && request.slice(0, 4) === 'http') {
    return axios({
      method: 'GET',
      url: request,
    })
  }
  let req = {
    method: (request.method || 'GET').toUpperCase(),
    url: request.url || '',
    query: request.query || {},
    data: request.data || {},
    dataType: (request.dataType || 'json').toLowerCase(),
  }
  // host
  if (req.url.slice(0, 4) !== 'http') {
    let host = HOST(req.url)
    req.url = host + req.url
  }
  // 默认参数 token + pub_id
  const pub_id =
    state.route && state.route.params && state.route.params.publicationId
  let query = Object.assign(
    {
      platform: 'console',
      token: getUserToken(),
      pub_id: pub_id,
      publication: pub_id,
    },
    req.query,
  )
  if (req.method === 'GET') {
    query = Object.assign(query, req.data)
  }
  req.url = `${req.url}?${Qs.stringify(query)}`
  // data 默认 json
  if (req.dataType === 'form') {
    req.data = Qs.stringify(req.data)
  } else if (req.dataType === 'json') {
    req.data = encodeURIComponent(JSON.stringify(req.data))
  }
  let options = {
    method: req.method,
    url: req.url,
    data: req.data,
  }
  if (req.method === 'GET') {
    delete options.data
  }
  return axios(options)
}

export const get = function(url, params) {
  return Ajax({
    url: url,
    data: params,
  })
}

/**
 * 标准 form-data 的 post 请求
 * @param url
 * @param data {object} form data 的数据，键值对
 * @param queryObject {object} query 的参数，键值对 object
 * @returns {AxiosPromise}
 */
const post = function(url, data, queryObject) {
  return Ajax({
    method: 'post',
    url: url,
    query: queryObject,
    dataType: 'form',
    data: data,
  })
}

/* eslint-enable */

/**
 * ========== 账号相关 ==========
 */

/**
 * 获取手机验证码
 * @param {String}  phoneNumber
 * @param {String} sessionCode
 */
export function sendVerifyCode(phoneNumber, sessionCode) {
  return get('/v1/account.sendVerification', {
    phone: phoneNumber,
    code: sessionCode,
  })
}

/**
 *
 * @param phoneNumber
 * @param sessionCode
 * @param verifyCode
 * @returns {*}
 */
export function loginByPhone(phoneNumber, sessionCode, verifyCode) {
  return get('/v1/account.auth', {
    phone: phoneNumber,
    code: sessionCode,
    verify: verifyCode,
  })
}

/**
 * 绑定手机号
 * @param phoneNumber
 * @param sessionCode
 * @param verifyCode
 * @returns {*}
 */
export function bindPhone(phoneNumber, sessionCode, verifyCode) {
  return get('/v1/account.update', {
    phone: phoneNumber,
    code: sessionCode,
    verify: verifyCode,
  })
}

/**
 * 获取账号信息
 * @returns {AxiosPromise}
 */
export function getAccountInfo() {
  return get('/v1/account.info', {})
}

export function checkAdmin(publicationId) {
  return get('/v2/publication.checkAdmin', {publication: publicationId})
}

/**
 * 查询用户是否有管理员权限
 * @returns {AxiosPromise}
 */
export function checkAccountAccess() {
  return Ajax({
    url: `/v1/quiz.lib.listAll`,
  })
}

/**
 * 查询用户是否扫描了二维码
 * @param scene
 * @returns {*}
 */
export function checkSubscribe(scene) {
  return axios.get(
    `http://api.readland.cn/v1/wechat.web/cs?scene=${scene}&page=query`,
  )
  // return get(`/v1/wechat.web/cs`, {
  //   page:'query',
  //   scene,
  // })
}

/**
 * 查询用户是否绑定过微信公众号
 * @param uid
 */
export function checkHasOpenId(uid) {
  // TODO 不检查 Open ID 了
  return new Promise(resolve => {
    resolve({
      ok: true,
      hasOpenId: true
    })
  })
  return get(`/v1/account.hasOpenid`, {
    uid: uid,
    app_id: APP_ID,
  })
}

/**
 * 查询用户是否付费
 * @param pubId
 */
export function checkPrePaid(publicationId) {
  return get(`/v2/publication.isPrepaid`, {
    publication: publicationId,
  })
}

/**
 * 检查认证状态 查询用户 level
 * @returns {*}
 */
export function checkAuthStatus() {
  return get(`/v2/mina.account.info`)
}

export function useInvitation(code) {
  return get(`/v2/mina.account.open`, {
    invitation: code,
  })
}

/**
 *  ========== App 相关 ==========
 */
/**
 * 获取 AppInfo
 * @param appId
 * @returns {*}
 */
export function getAppInfo(appId) {
  return get('/v2/mina.app.info', {
    app_id: appId,
    sync: 1,
  })
}

export function getExtAppList(appId) {
  return get('/v1/mina.app.ext.listApps', {
    app_id: appId,
  })
}

/**
 * 获取最新的模板号
 * @returns {AxiosPromise}
 */
export async function getTemplateId(appId, pubType) {
  if (pubType === 'podcast') {
    pubType = 'podcast'
  } else {
    pubType = 'content'
  }
  let res = await get('/v2/mina.template.getNewest', {
    app_id: appId,
  })
  let templateId = res.templates.find(e => {
    return String(e.type) === pubType
  }).template_id
  return templateId
}

/**
 * 发布体验版
 * @param appId
 * @param templateId
 * @param config 小程序的 extConfig
 * @returns {*}
 */
export function publishExperienceTemplate(appId, templateId, config, merged) {
  return Ajax({
    url: '/v2/mina.app.commit',
    method: 'post',
    query: {
      ext_config: JSON.stringify(config),
      app_id: appId,
      template: templateId,
      merged: merged || 'new',
    },
  })
}

/**
 * 提审当前体验版
 * @param appId
 * @param address
 * @returns {*}
 */
export function submitExperienceTemplate(appId, address = 'pages/page/page') {
  return get('/v2/mina.app.submitAudit', {
    app_id: appId,
    address,
  })
}

/**
 * 提审轻芒
 * @param appId
 * @param address
 * @returns {*}
 */
export function submitExperienceTemplateQingmang(
  appId,
  address = 'pages/page/page',
) {
  return get('/v2/mina.app.internalAudit', {
    app_id: appId,
    address,
  })
}

/**
 *  ========== Publication 相关 ==========
 */
/**
 * 获取账号下的单个 publication
 * @param pub_id
 * @returns {*}
 */
export async function getPublication(pub_id, refresh) {
  let res
  res = await Ajax({
    url: '/v2/publication.get',
    data: {
      publication_id: pub_id,
      refresh: refresh,
    },
  })
  if (res.ok) {
    const publication = res.publication
    if (publication.appId === 'wx05790b1180642960') {
      delete res.publication.appId
    }
  }
  return Promise.resolve(res)
}

/**
 * 获取单个 publication Scope
 * @param pub_id
 * @returns {*}
 */
export async function getPublicationScopes(pub_id = '') {
  let res
  res = await Ajax({
    url: '/v2/publication.getScopes',
    data: {
      publication_id: pub_id,
    },
  })
  return Promise.resolve(res)
}

/**
 * 创建一个 publication
 * @param name
 * @param pub_type
 * @returns {*}
 */
export function createPublication(name, type) {
  if (!['content', 'podcast', 'quiz'].includes(type)) {
    type = 'content'
  }
  // 播客小程序使用 v2 创建
  if (type === 'podcast') {
    return Ajax({
      url: '/v2/publication.create',
      data: {
        name: name,
        type: type,
      },
    })
  }
  return Ajax({
    url: '/ng/v1/publication.create',
    data: {
      name: name,
      pub_type: type,
    },
  })
}

/**
 * 配置一个 publication
 * @param publicationId
 * @param publicationData {name, logo, description, status}
 * @returns {*}
 */
export function updatePublication(publicationId, publicationData) {
  return Ajax({
    method: 'POST',
    url: '/v2/publication.update',
    query: {
      pub_id: publicationId,
    },
    dataType: 'form',
    data: publicationData,
  })
}

/**
 * 配置一个 publication
 * @param publicationId
 * @param publicationData {name, logo, description, status}
 * @returns {*}
 */
export function updatePublicationConfig(publicationId, config) {
  return updatePublication(publicationId, {
    config: JSON.stringify(config),
  })
}
/**
 * 发布一个 publication
 * @param publicationId
 * @param [wxappId]
 * @returns {*}
 */
export function publishPublication(publicationId, wxappId) {
  return get('/ng/v1/publication.publish', {
    pub_id: publicationId,
    app_id: wxappId,
  })
}

/**
 * 获取一个 publication 的所有用户 list
 * @param publicationId {Number}
 * @param params {object}
 * @returns {*}
 */
export function getPublicationUserList(publicationId, params) {
  return get('/v2/publication.member.search', {
    pub_id: publicationId,
    role: params.roleType,
    status: params.roleStatus,
    uid: params.uid,
    user_name: params.user_name,
  })
}

export function deletePublication(publicationId) {
  return get('/ng/v1/publication.delete', {
    pub_id: publicationId,
  })
}

/**
 * 读取一个 publication 的积分纪录列表
 * @param {*} publication_id
 * @param {*} params
 * @returns
 */
export function getPublicationScoreRecords(publication_id, params) {
  return get('/v2/publication.score.list', {
    ...params,
    publication_id: publication_id
  })
}

/**
 *  ========== content publication ==========
 */

/**
 * 往 content publication 里面添加杂志
 * @param {Number} publicationId
 * @param {Array} magazineIdArray
 * @returns {*}
 */
export function addMagazineToContentPublication(
  publicationId,
  magazineIdArray,
) {
  return get('/ng/v1/contentPublication.magazine.add', {
    pub_id: publicationId,
    mids: magazineIdArray.join(','),
  })
}

/**
 * 获取 publication 的评论列表
 * @param publicationId
 * @param {object} [props]
 * @param {string} [props.status = ['reviewing', 'approved', 'rejected', 'needApproval']] 按照评论的状态筛选
 * @param {array} [props.userIds] 按照 userId 过滤
 * @param {string} [props.postType]
 * @param {number} [props.max = 10]
 * @param {string} [props.docId]
 * @returns {*}
 */
export function getPublicationPostList(publicationId, props) {
  return get('/ng/v1/contentPublication.post.list', {
    pub_id: publicationId,
    review_status: props.status,
    show_user_ids: props.userIds.join(','),
    post_types: props.postType,
    max: props.max || 10,
    docid: props.docId,
  })
}

export function getPublicationPostNoteList(publicationId, props) {
  const params = {
    publication_id: publicationId,
    max: props.max || 10,
  }
  if (props.moderation_type) {
    params.moderation_type = props.moderation_type
  }
  if (props.content_type) {
    params.content_type = props.content_type
  }
  return get('/v2/community.mixed.filter', params)
}

/**
 * 获取 content publication 的评论数据
 * @param publicationId
 * @returns {*}
 */
export function getContentPublicationPostStatistics(publicationId) {
  return get('/ng/v1/contentPublication.post.statistics.get', {
    pub_id: publicationId,
  })
}

/**
 * 通过一条一级评论
 * @param {number} postId
 * @param {number} magazineId
 * @returns {*}
 */
export function approvePost(postId, magazineId) {
  return get('/ng/v1/post.approve', {
    post_id: postId,
    mid: magazineId,
  })
}

/**
 * 通过一条二级评论
 * @param {number} commentId
 * @param {number} magazineId
 * @returns {*}
 */
export function approveComment(commentId, magazineId) {
  return get('/v2/community.reply.setReviewStatus', {
    reply_id: commentId,
    status: 0,
  })
  // return get('/ng/v1/action.comment.approve', {
  //   comment_id: commentId,
  //   mid: magazineId,
  // })
}
export function rejectComment(commentId, magazineId) {
  return get('/v2/community.reply.setReviewStatus', {
    reply_id: commentId,
    status: 2,
  })
  // return get('/ng/v1/action.comment.approve', {
  //   comment_id: commentId,
  //   mid: magazineId,
  // })
}

/**
 * 删除一条一级评论
 * @param {number} postId
 * @param {number} magazineId
 * @returns {*}
 */
export function deleteNote(noteId) {
  return get('/v2/community.note.delete', {
    note_id: noteId,
  })
}

/**
 * 删除一条一级评论
 * @param {number} postId
 * @param {number} magazineId
 * @returns {*}
 */
export function deletePost(postId, magazineId) {
  return get('/ng/v1/post.delete', {
    post_id: postId,
    mid: magazineId,
  })
}

/**
 * 删除一条二级评论
 * @param {number} commentId
 * @param {number} magazineId
 * @returns {*}
 */
export function deleteComment(commentId, magazineId) {
  return get('/ng/v1/action.comment.remove', {
    comment_id: commentId,
    mid: magazineId,
  })
}

export function deleteReply(commentId, publicationId) {
  return get('/v2/community.reply.delete', {
    reply_id: commentId,
    publication_id: publicationId,
  })
}

/**
 *  ========== Lib 相关 ==========
 */

/**
 * 获取本账号的题库列表
 * @returns {AxiosPromise}
 */
export function getQuizLibList(publicationId) {
  return Ajax({
    method: 'GET',
    url: `/v1/quiz.lib.list`,
    data: {
      publication: publicationId,
      include_stat: 1,
    },
  })
}

/**
 * 获取全部的题库列表
 * @returns {AxiosPromise}
 */
export function getQuizLibListAll() {
  return Ajax({
    method: 'GET',
    url: `/v1/quiz.lib.listAll`,
    data: {
      include_stat: 1,
    },
  })
}

/**
 * 获取单个题库的基本信息
 * @param libId
 * @returns {AxiosPromise}
 */
export function getQuizLibInfo(libId) {
  const params = {
    id: libId,
    include_stat: 1,
  }
  return get('/v1/quiz.lib.get', params)
}

export function getQuizLibStatusInfo(libId) {
  return get('/v1/quiz.lib.question.count', {lib: libId})
}

export function getQuizLibDailyData(libId) {
  const date = getDailyDate()
  const params = {
    lib: libId,
    date,
    range: -7,
  }
  return get('/v1/quiz.lib.stat.daily', params)
}

/**
 * 增删题库
 * @param {Object} libInfo
 * @returns {AxiosPromise}
 */
export function createQuizLib(libInfo) {
  // const publicationId = libInfo.publication
  return post('/v1/quiz.lib.create', libInfo)
}

export function removeQuizLib(libId) {
  // GA埋点
  return get('/v1/quiz.lib.remove', {id: libId})
}

/**
 * 上线/下线题库
 */
export function publishQuizLib(libId) {
  return get('/v1/quiz.lib.publish', {id: libId})
}

export function unpublishQuizLib(libId) {
  return get('/v1/quiz.lib.close', {id: libId})
}

/**
 * 更新题库基本信息
 * @param {Object} libInfo
 * @returns {AxiosPromise}
 */
export function updateQuizLibInfo(libInfo) {
  return post('/v1/quiz.lib.update', libInfo)
}

/**
 * 获取题库全部题目
 * @param {Number} libId 题库 id
 * @param {Number} start 开始的位置
 * @param {Number} max 每页多少条
 * @returns {AxiosPromise}
 */
export function getLibQuestionList(libId, start = 0, max = 20, status) {
  return Ajax({
    method: 'GET',
    url: `/v1/quiz.lib.question.list`,
    data: {
      lib: libId,
      start,
      max,
      status,
    },
  })
}

/**
 * 搜索题库中的题目
 * @param libId
 * @param keyWord
 * @param start
 * @param max
 * @param status
 * @returns {*}
 */
export function searchQuestion(libId, keyWord, start = 0, max = 20, status) {
  const query = {
    lib: libId,
    query: keyWord,
    start,
    max,
    status,
  }
  return get(`/v1/quiz.lib.question.search`, query)
}

/**
 * 新增题库中的题目
 * @param libId
 * @param question
 */
export function addLibQuestion(libId, question) {
  // GA埋点
  return Ajax({
    url: `/v1/quiz.lib.question.add`,
    data: {
      lib: libId,
      ...question,
    },
  })
}

/**
 * 删除题库中的某一道题
 * @param libId
 * @param questionId
 * @returns {AxiosPromise}
 */
export function removeLibQuestion(libId, questionId) {
  // GA埋点
  return Ajax({
    url: `/v1/quiz.lib.question.remove`,
    data: {
      lib: libId,
      id: questionId,
    },
  })
}

/**
 * 修改题库中的一道题
 * @param libId
 * @param question
 * @returns {AxiosPromise}
 */
export function updateLibQuestion(libId, question) {
  // GA埋点
  return Ajax({
    url: `/v1/quiz.lib.question.update`,
    data: {
      lib: libId,
      ...question,
    },
  })
}

/**
 * 创建活动
 * @param libId
 * @param appId
 * @param awardInfo
 * @returns {*}
 */
export function createLibAward(libId, appId, awardInfo) {
  const params = {
    lib: libId,
    app_id: 'wx3e0a5430ef91b0e8',
    ...awardInfo,
  }
  return get('/v1/quiz.award.create', params)
}

/**
 * 删除活动
 * @param awardId
 * @param appId
 * @returns {*}
 */
export function removeLibAward(awardId, appId = '') {
  const params = {
    id: awardId,
    app_id: appId,
  }
  return get('/v1/quiz.award.remove', params)
}

/**
 * 更新活动
 * @param awardId
 * @param awardInfo
 * @returns {*}
 */
export function updateLibAward(awardId, awardInfo) {
  const params = {
    id: awardId,
    ...awardInfo,
  }
  return get('/v1/quiz.award.update', params)
}

/**
 * 获取特定题库的活动
 * @param libId
 * @param appId
 * @returns {*}
 */
export function getLibAwardList(libId, appId = '') {
  const params = {
    lib: libId,
    app_id: appId,
  }
  return get('/v1/quiz.award.list', params)
}

/**
 * 获取特定题库的全部活动
 * @param libId
 * @param appId
 * @returns {*}
 */
export function getLibAwardListAll(libId, appId = '') {
  const params = {
    lib: libId,
    app_id: appId,
  }
  return get('/v1/quiz.award.all', params)
}

/**
 * 获取特定活动的详情
 * @param awardId
 * @param libId
 * @returns {*}
 */
export function getLibAwardDetail(awardId, libId) {
  return get(`/v1/quiz.award.detail`, {
    id: awardId,
    lib: libId,
  })
}

/**
 * 获取登录用户任务
 * @param publicationId
 * @param template
 * @returns {*}
 */
export function taskMine(publicationId, template) {
  return get(`/v1/task.mine`, {
    pub_id: publicationId,
    template: template,
  })
}

/**
 *  ========== magazine 相关 ==========
 */

/**
 * 发布一本杂志
 * @param magazineId {number}
 * @returns {*}
 */
export function publishMagazine(magazineId) {
  return get('/ng/v1/magazine.publish', {
    mid: magazineId,
  })
}

/**
 * 下线一本杂志
 * @param magazineId {number}
 * @returns {*}
 */
export function offlineMagazine(magazineId) {
  return get('/ng/v1/magazine.offline', {
    mid: magazineId,
  })
}

/**
 * 删除一本杂志
 * @param {number} magazineId
 * @returns {*}
 */
export function deleteMagazine(magazineId) {
  return get(`/ng/v1/magazine.delete`, {
    mid: magazineId,
  })
}

export function previewMagazine(magazineId) {
  return get('/ng/v1/magazine.preview', {
    mid: magazineId,
  })
}

/**
 * 将给定列表按照发布时间调整排序
 * @param magazineId {Number}
 * @param publicationId {Number}
 * @return {AxiosPromise}
 */
export function rearrangeMagazine(magazineId, publicationId) {
  return get('/v2/pool.article.setAsPublishedOrder', {
    publication: publicationId,
    list: `m${magazineId}`,
  })
}

/**
 * 调整杂志中的文章排序
 * @param publicationId {Number}
 * @param columnId {Number}
 * @param position {Number}
 * @param doc_ids {Array}
 * @return {AxiosPromise}
 */
export function magazineArrangeArticleIndex({
  publicationId,
  columnId,
  position,
  doc_ids,
}) {
  return Ajax({
    url: `/v2/pool.column.moveDocs`,
    data: {
      publication: publicationId,
      column: columnId,
      position,
      doc_ids: doc_ids.join(),
    },
  })
}

/**
 * 获取特定杂志的基本信息
 * @param magazineId
 * @returns {*}
 */
export function getMagazineInfo(magazineId) {
  return get('/v2/pool.list.getMagazineInfo', {
    mid: magazineId,
    need_cover: true,
  })
}

/**
 * 获取特定杂志的基本数据
 * @param magazineId
 * @returns {*}
 */
export function getMagazineDailyData(magazineId) {
  return get(`/ng/v1/magazine.statistics.get`, {
    mid: magazineId,
  })
}

export function getMagazineArticleCount(magazineId) {
  return get(`/v2/pool.article.count`, {
    list: `m${magazineId}`,
  })
}

/**
 *  ========== basic ==========
 */

/**
 * 获取特定杂志的 Config
 * @param {Number} magazineId
 * @returns {*}
 */
export function getMagazineConfig(magazineId) {
  return get('/ng/v1/magazine.config.get', {
    mid: magazineId,
    need_cover: true,
  })
}

/**
 * 更新特定杂志的 Config
 * @param magazineId
 * @param config
 * @returns {*}
 */
export function updateMagazineConfig(magazineId, config) {
  return Ajax({
    method: 'POST',
    url: '/ng/v1/magazine.config.update',
    query: {
      mid: magazineId,
      action: 'set',
    },
    data: config,
  })
}

/**
 *  ========== content provider ==========
 */

/**
 * 获取一个杂志的文章列表
 * @param {Number} mid
 * @param {Boolean} fromLatest: 是否是最新
 * @param {Boolean} fromProvider: 是否是来自 provider
 * @param {Number} providerId: 可选，是否筛选了 provider
 * @returns {*}
 */
export function getMagazineArticleList(
  mid,
  fromLatest,
  fromProvider,
  providerId = undefined,
  max = 10,
) {
  return Ajax({
    url: '/ng/v1/timeline.magazine.get',
    data: {
      mid: mid,
      fromLatest: fromLatest,
      fromProvider: fromProvider,
      fromXiaohua: false,
      fromKeyword: false,
      providerId,
      max,
      isTest: true,
    },
  })
}

/**
 * 获取一个杂志的订阅源列表
 * @param {number} magazineId
 * @returns {*}
 */
export function getMagazineProviders(magazineId) {
  return get(`/ng/v1/magazine.provider.get`, {mid: magazineId})
}

/**
 * 搜索内容源
 * @param {String} input
 * @param type {string} 类型: word,url
 * @returns {*}
 */
export function searchProvider(input, type) {
  return get('/ng/v1/provider.search', {
    word: type === 'word' ? input : encodeURI(input),
  })
}

/**
 * 通过 URL 搜索文章
 * @param url {string}
 * @returns {*}
 */
export function searchArticleByUrl(url) {
  return get('/v2/cubita.article.fetch', {
    format: 'html',
    url: encodeURI(url),
    force: 1,
    sync: 1,
  })
}

/**
 * 搜一本杂志内部的文章
 * @param {Number} magazineId
 * @param {string} word
 * @returns {Promise}
 */
export function searchArticleInMagazine(magazineId, word) {
  return get(`/ng/v1/magazine.article.search`, {
    word: word,
    mid: magazineId,
  })
}

/**
 * 添加一个内容源到杂志中
 * @param magazineId {Number}
 * @param providerId {Number}
 * @param url {string}
 * @returns {*}
 */
export function addProviderToMagazine(magazineId, providerId, url) {
  return get('/ng/v1/magazine.provider.subscribe', {
    mid: magazineId,
    provider_id: providerId,
    url: url,
  })
}

/**
 * 从杂志中删除一个内容源
 * @param magazineId {Number}
 * @param providerId {Number}
 * @returns {*}
 */
export function removeProviderFromMagazine(magazineId, providerId) {
  return get('/ng/v1/magazine.provider.forbid', {
    mid: magazineId,
    provider_id: providerId,
  })
}

/**
 * 添加一篇文章到杂志中
 * @param {Number} magazineId
 * @param {String} docId
 * @returns {*}
 */
export function addArticleToMagazine(pubId, magazineId, docId) {
  return get('/v2/pool.article.changeColumns', {
    publication: pubId,
    docs: docId,
    removed: '',
    added: magazineId,
  })
}

/**
 * 从杂志中移除文章
 * @param {Number} publicationId
 * @param {Number|String|Number[]} magazineId
 * @param {String} docId
 * @returns {*}
 */
export function removeArticleFromMagazine(publicationId, magazineId, docId) {
  let removed
  if (typeof magazineId === 'number' || typeof magazineId === 'string') {
    removed = magazineId
  } else {
    removed = magazineId.join(',')
  }
  return get('/v2/pool.article.changeColumns', {
    publication: publicationId,
    docs: docId,
    removed: removed,
    added: '',
  })
}

/**
 * 在杂志中置顶一篇文章
 * @param magazineId {number}
 * @param docId {string}
 * @returns {*}
 */
export function pinArticleInMagazine(pubId, magazineId, docId) {
  return get('/v2/pool.column.pinArticle', {
    publication: pubId,
    column: magazineId,
    doc_id: docId,
  })
}

/**
 * 在杂志取消置顶一篇文章
 * @param magazineId {number}
 * @param docId {string}
 * @returns {*}
 */
export function unpinArticleInMagazine(pubId, magazineId, docId) {
  return get('/v2/pool.column.unpinArticle', {
    publication: pubId,
    column: magazineId,
    doc_id: docId,
  })
}

/**
 * 手工添加一篇文章到素材库
 */
export function addArticleToResource(publicationId, docId) {
  return get('/v2/pool.article.add', {
    publication: publicationId,
    doc_id: docId,
  })
}

/**
 * 手工从素材库移除一篇文章
 * @param publicationId {Number}
 * @param docId {String}
 */
export function removeArticleFromResource(publicationId, docId) {
  return get('/v2/pool.article.remove', {
    publication: publicationId,
    doc: docId,
  })
}

/**
 *  ========== user ==========
 */

/**
 * 搜索一本杂志下的用户
 * @param magazineId {Number}
 * @param params {Object}
 * @param params.uid {number}
 * @param params.name {string}
 * @param params.role {string} 角色 [stranger, member, contributor, admin]
 * @returns {*}
 */
export function searchMemberInMagazine(
  magazineId,
  params = {
    uid: '',
    name: '',
    role: '',
  },
) {
  return get(`/ng/v1/magazine.member.search`, {
    mid: magazineId,
    uid: (params && params.uid) || '',
    user_name: (params && params.name) || '',
    role: (params && params.role) || '',
  })
}

/**
 * 在某个 publication 禁言用户
 * @param publicationId {number}
 * @param uid {number}
 * @returns {*}
 */
export function blockUserInPublication(publicationId, uid) {
  return get('/v2/publication.member.block', {
    pub_id: publicationId,
    uid,
  })
}

/**
 * 在某个 publication 下取消禁言用户
 * @param publicationId {number}
 * @param uid {number}
 * @returns {*}
 */
export function unblockUserInPublication(publicationId, uid) {
  return get('/v2/publication.member.unblock', {
    pub_id: publicationId,
    uid,
  })
}

/**
 * 获取某个 publication 下用户的所有 role 信息
 * @param publicationId
 * @param userId
 * @param mid
 * @returns {*}
 */
export function getUserRoleInPublication(publicationId, userId, mid = '') {
  return get(`/ng/v1/magazine.member.get`, {
    mid: mid,
    uid: userId,
    pub_id: publicationId,
  })
}

/**
 * 修改一个用户在杂志下的 role
 * @param {number} magazineId
 * @param {number} userId
 * @param {string} role: admin, contributor, member, stranger
 * @returns {*}
 */
export function updateUserRoleInMagazine(magazineId, userId, role) {
  return get(`/ng/v1/magazine.member.update`, {
    mid: magazineId,
    uid: userId,
    role,
  })
}

/**
 *  ========== Page 相关 ==========
 */
/**
 * 新增一个 Page
 * @param name {string}
 * @param publicationId {number}
 * @returns {*}
 */
export function createPublicationPage(name, publicationId, type) {
  return Ajax({
    url: '/v2/page.create',
    dataType: 'form',
    method: 'POST',
    data: {
      publication: publicationId,
      name: name,
      type: type,
    },
  })
}

/**
 * 获取一个 Page
 * @param publicationId {Number}
 * @param [pageId] {Number} 不传的话获取 publication 下的所有 page
 * @returns {*}
 */
export function getPublicationPage(publicationId, pageId, type) {
  return Ajax({
    url: '/v2/page.get',
    data: {
      page_id: pageId,
      pub_id: publicationId,
      page_types: type,
    },
  })
}

/**
 * 调整 page 的顺序
 * @param publicationId {Number}
 * @param pageIds {Array} pages 的 Id 组成的 list
 */
export function updatePublicationPageIndex(publicationId, pageIds) {
  return Ajax({
    url: `/ng/v1/page.index.update`,
    dataType: 'form',
    method: 'post',
    data: {
      pub_id: publicationId,
      page_ids: pageIds.join(','),
    },
  })
}

/**
 * 删除一个 Page
 * @param pageId {number}
 * @returns {*}
 */
export function removePublicationPage(pageId) {
  return get('/ng/v1/page.delete', {
    page_id: pageId,
  })
}

/**
 * 更新一个 Page 的基本属性
 * @param pageId {number}
 * @param data {Object}
 * @property data.pubId {Number}
 * @property data.name {String}
 * @property [data.index] {Number} ? 这个似乎没有什么用，就不管了
 * @property data.config {Object}
 * @property data.config.foregroundColor {String} 没有#的HEX色值
 * @property data.config.backgroundColor {String} 没有#的HEX色值
 * @property data.config.showPageName {Boolean}
 * @property [data.config.showItemHeader] {Boolean}
 * @property data.config.showCommentSize {Number}
 * @returns {*}
 */
export function updatePublicationPage(pageId, data) {
  return Ajax({
    method: 'POST',
    url: '/ng/v1/page.update',
    query: {
      page_id: pageId,
    },
    data: data,
  })
}

/**
 * 更新一个 page 的 timeline
 * @param pageId {Number}
 * @param sectionList {Array} 内含 section 的数组
 * @returns {AxiosPromise}
 */
export function updatePageTimeline(pubId, pageId, sectionList) {
  return Ajax({
    method: 'POST',
    url: '/v2/page.cards.set',
    dataType: 'form',
    data: {
      publication: pubId,
      page: pageId,
      cards: JSON.stringify(sectionList),
    },
  })
}

/**
 * 获取一篇文章
 * @param docId {String}
 * @param mid {Number}
 * @returns {*}
 */
export function getArticle(docId, template, pubId) {
  return Ajax({
    url: '/v2/pool.article.fetchEvent',
    data: {
      doc_id: docId,
      pub_id: pubId,
      template: template || 'raml',
      is_check_copyright: '0',
    },
  })
}

/**
 *  ========== Admin 相关 ==========
 */

/**
 * 通过一个题目
 * @param questionId
 * @returns {*}
 */
export function resolveLibQuestion(questionId) {
  return get('/v1/quiz.lib.question.publish', {id: questionId})
}

/**
 * 拒绝一个题目
 * @param questionId
 * @returns {*}
 */
export function rejectLibQuestion(questionId) {
  return get('/v1/quiz.lib.question.reject', {id: questionId})
}

/**
 *
 * @param uid {number} 用户 id
 * @param params {object}
 * @param params.templateId {string} 模板 Id
 * @param params.url {string} [跳转的网页]
 * @param params.appId {string} [小程序 AppId]
 * @param params.path {string} [小程序路径]
 * @param params.data {JSON5} 消息 data
 */
export function sendTemplateMessage(uid, params) {
  const messageInfo = {
    uid: uid,
    template_id: params.templateId,
    url: params.url,
    appid: params.appId,
    pagepath: params.path,
    json_data: params.data,
  }
  return post('/v1/wechat.web/cs', messageInfo, {page: 'send_template'})
}

/**
 * 栏目列表
 * @param options
 * @param options.publication {Number}
 */
export function columnList(with_catalogs) {
  const data = {}
  if (with_catalogs === true) {
    data.with_catalogs = 1
  }
  return Ajax({
    url: '/v2/pool.column.list',
    data: data,
  })
}

/**
 * 创建栏目
 * @param options
 * @param options.pub_id {Number}
 */
export function columnCreate(pub_id, name, content_type) {
  return Ajax({
    url: '/v2/pool.list.createMagazine',
    data: {
      pub_id: pub_id,
      name: name,
      content_type: content_type || '',
    },
  })
}

/**
 * 创建栏目 v1
 * @param magazineName {String}
 * @param magazineType {String} values: ['public', 'private']
 * @param magazineCover {String} image URL
 * @returns {*}
 */
export function columnCreateV1(
  publicationId,
  magazineName,
  magazineType = 'private',
  magazineCover = '',
) {
  return Ajax({
    url: '/ng/v1/magazine.create',
    data: {
      pub_id: publicationId,
      name: magazineName,
      magazine_type: magazineType,
      cover_url: magazineCover,
    },
  })
}

/**
 * 文章列表
 * @param options
 * @param options.publication {Number}
 * @param options.list {String}
 */
export function articleList(options) {
  return Ajax({
    url: '/v2/pool.article.list',
    data: options,
  })
}

/**
 *
 * @param options
 */
export function articleEventsGet(options) {
  return Ajax({
    url: '/v2/pool.article.events',
    data: options,
  })
}

/**
 * Editor 创建文章
 * @param publicationId {Number}
 * @return {AxiosPromise}
 */
export function editorArticleCreate(publicationId, type) {
  const data = {
    publication: publicationId,
  }
  if (type === 'about') {
    data.package_name = `qingmang.publication.${publicationId}.about`
  } else if (type === 'show') {
    data.package_name = `qingmang.publication.${publicationId}`
  } else if (type === 'course') {
    data.package_name = `qingmang.publication.${publicationId}.course`
  } else if (type === 'story') {
    data.package_name = `qingmang.publication.${publicationId}.story`
  } else if (type === 'book') {
    data.package_name = `qingmang.publication.${publicationId}.book`
  } else if (type === 'article') {
    data.package_name = `qingmang.publication.${publicationId}.article`
  } else if (type === 'audio') {
    data.package_name = `qingmang.publication.${publicationId}.podcast`
  } else if (type === 'video') {
    data.package_name = `qingmang.publication.${publicationId}.video`
  }
  return Ajax({
    url: '/v2/cubita.article.create',
    data: data,
  })
}

/**
 * Editor 文章列表
 * @param publicationId {Number}
 * @returns {AxiosPromise}
 */
export function editorArticleList(publicationId, max, type, query) {
  // 课程 course
  let data = {
    publication: publicationId,
    max: max || 10,
    query: query || '',
  }
  if (type === 'about') {
    data.package_name = `qingmang.publication.${publicationId}.about`
    data.is_draft = '1'
  } else if (type === 'show') {
    data.package_name = `qingmang.publication.${publicationId}`
    data.is_draft = '1'
  } else if (type === 'course') {
    data.package_name = `qingmang.publication.${publicationId}.course`
  } else if (type === 'article') {
    data.package_name = `qingmang.publication.${publicationId}.article`
  }
  return Ajax({
    url: '/v2/pool.cubita.list',
    data: data,
  })
}

/**
 * Editor 删除文章
 * @param articleId {Number}
 * @param publicationId {Number}
 * @return {AxiosPromise}
 */
export function editorArticleDelete(articleId, publicationId) {
  return get('/v2/cubita.article.delete', {
    id: articleId,
    publication: publicationId,
  })
}

/**
 * Editor 文章详情
 * @param options
 */
export function editorArticleDetail(options) {
  return Ajax({
    url: '/v2/cubita.article.get',
    data: options,
  })
}

export function editorArticleDetailByDocId(docId) {
  return Ajax({
    url: '/v2/cubita.article.query',
    data: { doc_id: docId },
  })
}

/**
 * Editor 更新文章
 * @param query
 * @param query.id {Number} - 文章 articleId
 * @param query.publication {Number} - publicationId
 * @param data
 * @param [data.publish_strategy] {String} - 发布策略 默认 public, protect 是付费
 */
export function editorArticleUpdate(query, data) {
  // publich protect
  return Ajax({
    url: '/v2/cubita.article.update',
    dataType: 'form',
    method: 'POST',
    query,
    data,
  })
}

/**
 * Editor 上传多媒体
 * @param options
 */
export function editorMediaCreate(options) {
  return Ajax({
    url: '/v2/cubita.media.create',
    data: options,
  })
}

/**
 * Editor 生成预览文章 ticket
 * @param options
 */
export function editorArticlePreviewTicket(options) {
  return Ajax({
    url: '/v2/cubita.preview.generate',
    data: options,
  })
}

/**
 * Editor 发布文章
 * @param options
 * @param options.
 */
export function editorArticlePublish(options) {
  return Ajax({
    url: '/v2/cubita.article.publish',
    data: options,
  })
}

/**
 * Editor 首次发布文章
 * @param {Number} publicationId
 * @param {Number} articleId
 * @param {Number[]} magazineIdList
 * @return {AxiosPromise}
 */
export function editorArticlePublishFirst({
  publicationId,
  articleId,
  magazineIdList,
}) {
  return get(`/v2/pool.cubita.publish`, {
    publication: publicationId,
    id: articleId,
    added: magazineIdList.join(','),
  })
}

export function getShowCases() {
  return get(`/v1/mina.getShowcase`)
}

/**
 *  ========== 皮肤相关 ==========
 */

export function themeGetVariables(publicationId) {
  return get(`/v2/theme.query`, {
    publication: publicationId,
    preview_status: 0,
  })
}

export function themeGenerate({
  publicationId,
  themeName = 'default2',
  themeVariables,
  previewStatus = 0,
}) {
  return get(`/v2/theme.generate`, {
    theme: themeName,
    publication: publicationId,
    variables: JSON.stringify(themeVariables),
    preview_status: previewStatus,
  })
}

export function getTemplateList() {
  return Ajax({
    url: '/v2/push.template.list',
    data: {
      product: 'console',
    },
  })
}

export function pushJobList(appId, publicationId) {
  return Ajax({
    url: '/v2/push.job.list',
    data: {
      app_id: appId,
      publication: publicationId,
    },
  })
}

export function pushJobAdd(
  appId,
  publication,
  templateId,
  name,
  description,
  path,
) {
  return Ajax({
    url: '/v2/push.job.add',
    data: {
      app_id: appId,
      publication,
      template_id: templateId,
      texts: JSON.stringify([name, description]),
      params: JSON.stringify({
        path,
      }),
    },
  })
}

export function pushJobResume(id) {
  return Ajax({
    url: '/v2/push.job.resume',
    data: {
      id,
    },
  })
}

/**
 *  ========== 话题相关 ==========
 */

/**
 * Topic list
 * @param publicationId
 * @param max
 * @return {AxiosPromise}
 */
export function communityTopicListGet(publicationId, max = 20, filter = '') {
  return get(`/v2/community.topic.list`, {
    publication: publicationId,
    start: 0,
    max: max,
    filter
  })
}

/**
 * 创建 topic
 * @param publicationId {Number}
 * @param type {String} values: ['discuss', 'vote', 'choice']
 * @param title {String}
 * @param cover {String}
 * @param [content] {String}
 * @param [options] {Array}
 * @param [optionType] {String}
 * @param [deadline] {Number} ms
 * @return {null|AxiosPromise}
 */
export function communityTopicCreate({
  publicationId,
  type,
  title,
  cover,
  content,
  options,
  optionType,
  stretchType,
  deadline,
  organizationId,
  backgroundColor,
  textColor,
  status,
}) {
  if (!organizationId) {
    organizationId = ''
  }
  var extra = {}
  if (backgroundColor) {
    extra.backgroundColor = backgroundColor
  }
  if (textColor) {
    extra.textColor = textColor
  }
  extra = JSON.stringify(extra)
  switch (type) {
    case 'collect':
      return Ajax({
        url: `/v2/community.discuss.create`,
        data: {
          title,
          cover,
          content,
          org_id: organizationId,
          extra,
          status,
        },
      })
    case 'vote':
      return Ajax({
        url: `/v2/community.vote.create`,
        data: {
          title,
          cover,
          content,
          deadline,
          options: JSON.stringify(options),
          max_voting: optionType === 'single' ? 1 : options.length,
          is_stretch: stretchType,
          org_id: organizationId,
          extra,
          status,
        },
      })
    case 'discuss':
      return Ajax({
        url: `/v2/community.choice.create`,
        data: {
          title,
          content,
          cover,
          positive: '看好',
          negative: '不看好',
          org_id: organizationId,
          extra,
          status,
        },
      })
    default:
      return null
  }
}

export function communityTopicGet(publicationId, topicId) {
  return get(`/v2/community.topic.get`, {
    publication: publicationId,
    id: topicId,
  })
}

export function communityTopicDelete(publicationId, topicId) {
  return get(`/v2/community.topic.delete`, {
    publication: publicationId,
    id: topicId,
  })
}

export function communityTopicUpdateStatus(publicationId, topicId, status) {
  return get(`/v2/community.topic.updateStatus`, {
    publication: publicationId,
    id: topicId,
    status,
  })
}

export function communityTopicSearch(publicationId, keyword, filter = '') {
  return get(`/v2/community.topic.search`, {
    publication: publicationId,
    keyword,
    filter,
  })
}

/**
 * 返回全部的 organization
 *
 * @param {} publicationId
 */
export function organizationList(publicationId, max = 10) {
  return get(`/v2/publication.organization.list`, {
    publication: publicationId,
    max: max
  })
}

/**
 *
 * @param {*} publicationId
 * @param {*} organizationId
 * @param {*} userId
 */
export function setUserOrganization(publicationId, organizationId, userId) {
  return get(`/v2/publication.organization.setUserOrganization`, {
    publication: publicationId,
    org_id: organizationId,
    user_ids: userId,
    role: 'member',
  })
}

export function orderList(publicationId, max = 10) {
  return get(`/v2/publication.order.list`, {
    publication: publicationId,
    max: max,
  })
}
